const LINES: Record<string, { key: string; asksToConfigure: boolean }> = {
  NEW: { key: "dashboard.entityStatus.text-01", asksToConfigure: true },
  SERVICE_ON: { key: "dashboard.entityStatus.text-02", asksToConfigure: false },
  SERVICE_OFF: {
    key: "dashboard.entityStatus.text-03",
    asksToConfigure: false,
  },
  CANCELED: { key: "dashboard.entityStatus.text-04", asksToConfigure: true },
};

/** The line under the greeting; the ones asking to set the space up only show to whoever can. */
export const entityStatusLineKey = (
  status: string,
  canConfigure: boolean
): string | null => {
  const line = LINES[status] ?? {
    key: "dashboard.entityStatus.text-05",
    asksToConfigure: false,
  };
  return line.asksToConfigure && !canConfigure ? null : line.key;
};
